<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Thanks are due to Greg Tait for his work on the maps and cover page of this book. Thanks also to Greg McCann for allowing use of two of his photographs, Nos. 5 and 40, plus valuable advice.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?06b870f1